import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import 'bootstrap/dist/css/bootstrap.min.css';

import './tailwind.css'
import {WorkshopProvider} from "./Components/Common/WorkshopContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <WorkshopProvider>
    <App />
    </WorkshopProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
